




























































import Vue from 'vue'
import Shimmer from './Shimmer.vue'
export default Vue.extend({
  props: {
    hideExtra: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Shimmer
  },
  computed: {
    newMobileScreens(): boolean {
      return this.$store.getters.newMobileScreens
    }
  }
})
